import dayjs, { Dayjs } from "dayjs";
import { DatePickerProps } from "@mui/x-date-pickers-pro";
import { FieldPathValue, UseControllerProps } from "react-hook-form";
import { FieldPath, useController } from "react-hook-form";
import { AavoDatePicker } from "../../inputFields/AavoDatePicker";
import { dayJsToDateIsoString } from "src/utils/dayjsUtils.ts";

export interface FormDateFieldProps<
	TFieldValues extends object,
	TFieldName extends FieldPath<TFieldValues>,
> extends Omit<DatePickerProps<Dayjs>, "onChange" | "value"> {
	control: UseControllerProps<TFieldValues, TFieldName>["control"];
	name: UseControllerProps<TFieldValues, TFieldName>["name"];
	rules?: UseControllerProps<TFieldValues, TFieldName>["rules"];
}

export const FormDateField = <TFieldValues extends object, TFieldName extends FieldPath<TFieldValues>>({
	control,
	name,
	rules,
	...other
}: FormDateFieldProps<TFieldValues, TFieldName>) => {
	const { field, fieldState } = useController({
		name,
		control,
		rules,
		defaultValue: null as FieldPathValue<TFieldValues, TFieldName>,
	});

	const dayJsValue = field.value === null ? null : dayjs(field.value);

	const transformedField = {
		...field,
		value: dayJsValue,
		onChange: (date: Dayjs | null) => {
			field.onChange(date === null ? null : dayJsToDateIsoString(date));
		},
		ref: undefined,
	};

	return (
		<AavoDatePicker
			errorMessage={fieldState.error?.message}
			{...transformedField}
			{...other}
		/>
	);
};
